import axios from 'axios';
import { getToken, deleteData } from 'src/utils/sessionStorage';
import {
  LOGIN_FAILURE,
  LOGIN_REQUEST,
  LOGIN_SUCCESS,
  LOGOUT,
} from '../Auth/actionType';
import { toast } from 'react-toastify';
const baseUrl = process.env.REACT_APP_API_URL;
export const loginRequest = () => {
  return {
    type: LOGIN_REQUEST,
  };
};
export const loginSuccess = payload => {
  return {
    type: LOGIN_SUCCESS,
    payload,
  };
};
export const loginFailure = payload => {
  return {
    type: LOGIN_FAILURE,
    payload,
  };
};
export const logOut = () => {
  return {
    type: LOGOUT,
  };
};

const validateLoginResponse = (response) => {
	if (!response || typeof response !== 'object') {
		return { valid: false, error: 'Invalid response format' };
	}
	
	if (response.success !== true) {
		return { valid: false, error: 'Login failed' };
	}
	
	if (!response.token || typeof response.token !== 'string' || response.token.trim().length === 0) {
		return { valid: false, error: 'Invalid token received' };
	}
	
	if (response.token.length < 20) {
		return { valid: false, error: 'Token appears to be invalid' };
	}
	
	return { valid: true };
};

const verifyTokenWithServer = async (token) => {
	try {
		const response = await axios({
			method: 'get',
			url: `${baseUrl}/session/validate`,
			headers: {
				'x-access-token': token,
			},
			timeout: 5000,
		});
		return response.data && response.data.success === true;
	} catch (error) {
		if (error.response && error.response.status === 404) {
			console.warn('Token validation endpoint not available, skipping server verification');
			return true;
		}
		return false;
	}
};

export const loginUser = (payload, handleCaptchaId) => async dispatch => {
	dispatch(loginRequest());
	try {
		const res = await axios({
			method: 'post',
			url: `${baseUrl}/login`,
			data: payload,
		});
		
		if (res.status !== 200) {
			dispatch(loginFailure({ 
				errMessage: 'Authentication failed with invalid status', 
				isLoggedIn: false 
			}));
			toast.error('Authentication failed');
			handleCaptchaId();
			return;
		}
		
		const validation = validateLoginResponse(res.data);
		if (!validation.valid) {
			dispatch(loginFailure({ 
				errMessage: validation.error || 'Authentication failed', 
				isLoggedIn: false 
			}));
			toast.error(validation.error || 'Authentication failed');
			handleCaptchaId();
			return;
		}
		
		const isTokenValid = await verifyTokenWithServer(res.data.token);
		if (!isTokenValid) {
			dispatch(loginFailure({ 
				errMessage: 'Token validation failed. Please try again.', 
				isLoggedIn: false 
			}));
			toast.error('Token validation failed. Please try again.');
			handleCaptchaId();
			return;
		}
		
		dispatch(loginSuccess(res.data));
	} catch (err) {
		let errMessage = '';
		let isLoggedIn = false;
		if (err.response !== undefined && err.response.status === 500) {
			errMessage = 'Internal Server Error';
			toast.error(errMessage);
		} else if (err.response !== undefined && err.response.status === 400) {
			errMessage = err.response.data?.message || 'Invalid credentials';
			isLoggedIn = err.response.data?.isLoggedIn || false;
			toast.error(errMessage);
			handleCaptchaId();
		} else {
			errMessage = err.message || 'Network error';
			toast.error(errMessage);
			handleCaptchaId();
		}
		dispatch(loginFailure({ errMessage, isLoggedIn }));
	}
};

export const logoutUser = payload => dispatch => {
  axios({
    method: 'post',
    url: `${baseUrl}/logout`,
    headers: {
      'x-access-token': getToken(),
    },
  }).then(res => {
    dispatch(logOut());
  }).catch(err => {
    if (err.response !== undefined && err.response.status === 500) {
      toast.error("Internal Server Error");
    } else if (err.response !== undefined && err.response.status === 400) {
      toast.error(err.response.data.message);
    } else if (err.response !== undefined && err.response.status === 401 ) {
      deleteData("loginInfo");
      window.location.href = "/login";
    } else {
      toast.error(err.message);
    }
  });
};
